<template>
  <div class="background background-split-hero-banner">
    <component :is="tag" class="split-hero-banner">
      <StoryblokComponent
        v-if="image?.length === 1"
        :blok="image[0]"
        class="image"
        :size-hint="60"
        :size-hint-mobile="100"
        :quality="isPrimaryHeroBanner ? 90 : undefined"
        :fetch-priority="isPrimaryHeroBanner ? 'high' : undefined"
        :loading="isPrimaryHeroBanner ? 'eager' : 'lazy'"
      />
      <div class="content">
        <slot />
      </div>
    </component>
  </div>
</template>

<script setup>
const props = defineProps({
  image: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});

const { isPrimaryHeroBanner } = usePrimaryHeroBanner(
  props.image?.[0]?._uid ?? "split-hero-banner",
  props.image?.[0]
);
</script>

<style lang="scss" scoped>
.background {
  @include pair-1;
  .split-hero-banner {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
  }
  .image {
    display: block;
    aspect-ratio: 1;

    :deep(img) {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
  .content {
    margin: 2.5rem 1.5rem 4rem;
  }

  @include for-tablet-landscape-up {
    .split-hero-banner {
      min-height: 100vh;
      flex-direction: row;
    }
    .image {
      aspect-ratio: auto;
      width: 50%;
    }
    .content {
      width: 50%;
      max-width: calc($max-width / 2);
      align-self: end;
      margin: calc(var(--header-height) + 1rem) 0 5rem;
      padding: 0 4.5rem;
    }
  }
}
</style>
